import { CelebrationAvatar } from "@components/adapters/celebration/Avatar";
import type { AvatarProps } from "@components/contracts/Avatar.types";

export const Avatar: React.FC<AvatarProps> = (props) => (
  <CelebrationAvatar {...props} />
);

export type { AvatarProps };
